import { _mock } from './_mock';
import { cities } from './map/cities';

export const REGION_NAMES = ['default', ...cities.map((city) => city.city)];

export const _regions = [...Array(12)].map((_, index) => ({
  id: _mock.id(index),
  name: REGION_NAMES[index],
}));
